import React from "react";
import Box from "@mui/material/Box/Box";
import GeniePage from "../genie-page/GeniePage";
import GenieText from "../../core/genie-text/GenieText";

function Genie404() {
  return (
    <GeniePage>
      <Box>
        <GenieText fontSize={"large"} fontWeight={"bold"}>
          404
        </GenieText>
        <GenieText fontSize={"small"} paragraph>
          This page is not available.
        </GenieText>
      </Box>
    </GeniePage>
  );
}

export default Genie404;
